import React from "react";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import { Card, CardHeader, CardTitle, CardDescription } from '../components/ui/Card';
import { theme } from '../styles/theme';

const PageContainer = styled.div`
  min-height: 80vh;
  padding: ${theme.spacing['4xl']} ${theme.spacing.xl};
  background: ${theme.gradients.hero};
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: ${theme.spacing['4xl']};
`;

const PageTitle = styled.h1`
  font-size: ${theme.typography.fontSize['4xl']};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.secondary[900]};
  margin-bottom: ${theme.spacing.lg};
`;

const PageSubtitle = styled.p`
  font-size: ${theme.typography.fontSize.xl};
  color: ${theme.colors.secondary[600]};
  max-width: 600px;
  margin: 0 auto ${theme.spacing['2xl']} auto;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${theme.spacing['2xl']};
  margin-bottom: ${theme.spacing['4xl']};
`;

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: ${theme.spacing.xl};
`;

const ValueCard = styled(Card)`
  text-align: center;
  
  h4 {
    color: ${theme.colors.primary[700]};
    margin-bottom: ${theme.spacing.sm};
  }
`;

function Nosotros() {
  const { t } = useTranslation(['pages', 'common']);

  return (
    <PageContainer>
      <Container>
        <PageHeader>
          <PageTitle>{t('pages:about.title')}</PageTitle>
          <PageSubtitle>{t('pages:about.subtitle')}</PageSubtitle>
          <p style={{ 
            fontSize: theme.typography.fontSize.base, 
            color: theme.colors.secondary[600],
            maxWidth: '800px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            {t('pages:about.description')}
          </p>
        </PageHeader>

        <ContentGrid>
          <Card>
            <CardHeader>
              <CardTitle>{t('pages:about.mission.title')}</CardTitle>
              <CardDescription>
                {t('pages:about.mission.description')}
              </CardDescription>
            </CardHeader>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>{t('pages:about.vision.title')}</CardTitle>
              <CardDescription>
                {t('pages:about.vision.description')}
              </CardDescription>
            </CardHeader>
          </Card>
        </ContentGrid>

        <div style={{ textAlign: 'center', marginBottom: theme.spacing['2xl'] }}>
          <h2 style={{ 
            fontSize: theme.typography.fontSize['2xl'],
            fontWeight: theme.typography.fontWeight.bold,
            color: theme.colors.secondary[900],
            marginBottom: theme.spacing.xl
          }}>
            {t('pages:about.values.title')}
          </h2>
        </div>

        <ValuesGrid>
          {t('pages:about.values.items', { returnObjects: true }).map((value, index) => (
            <ValueCard key={index}>
              <h4>{value.title}</h4>
              <p style={{ color: theme.colors.secondary[600], margin: 0 }}>
                {value.description}
              </p>
            </ValueCard>
          ))}
        </ValuesGrid>
      </Container>
    </PageContainer>
  );
}

export default Nosotros;